/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum EntityTreeCssMarkersType {

    UNFINISHED_PATH_MARKER_CLASS = 'entity-tree-unfinished-path-origin-marker'
}
